import { Color, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'
import { transparentize } from 'polished'

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${Spacing.S40};
  height: ${Spacing.S40};
  border: 1px solid ${Color.Grey200};
  border-radius: 50%;
  background-color: ${Color.White};
  box-shadow: 0px 2px 4px 0px ${transparentize(0.8, Color.Grey950)};
`
